import React, { Component } from 'react';
import './index.css';

import * as _ from 'lodash'

import {isInFieldGroupList, splitIntoVisibleAndInvisibleItems} from '../Helpers'
import State from '../State'

function handleGroupClick({field, key}) {
  // console.log('click', field, key)
  State.action('selectGroup', {field: field, key: key})
}

class Column extends Component {
  render() {

    let h = this.props.h
    let {aboveVisibleHeight, visibleItems, belowVisibleHeight} = splitIntoVisibleAndInvisibleItems({
      items: this.props.items,
      windowTop: window.scrollY,
      windowBottom: window.scrollY + window.innerHeight,
      h: h
    })

    let col = []

    // Spacer element
    col.push(<div className="offscreen" key="above" style={{height: aboveVisibleHeight}}></div>)

    // Visible elements
    _.each(visibleItems, (d, i) => {
      if(this.props.field === 'RedactedSupportingInvoiceId') {
        let style = {
          height: h * d.summary.numNodes,
          width: State.columnWidths[this.props.field] + 'px'
        }

        let a = ''
        if(d.key !== '')
          a = <a target="_blank" href={"http://search.electoralcommission.org.uk/Api/Spending/Invoices/" + d.key}>View</a>

        col.push(<div key={d.pathId} style={style}>{a}</div>)
      } else {
        let style = {
          backgroundColor: isInFieldGroupList(State.selectedGroups, this.props.field, d.key) ? '#F4F4EE' : null,
          borderLeft: isInFieldGroupList(State.selectedGroups, this.props.field, d.key) ? '2px solid #919179' : null,
          height: h * d.summary.numNodes,
          width: State.columnWidths[this.props.field] + 'px'
        }
        col.push(<div onClick={() => handleGroupClick({field: this.props.field, key: d.key})} key={d.pathId} style={style}>{d.key}</div>)
      }
    })

    // Spacer element
    col.push(<div className="offscreen" key="below" style={{height: belowVisibleHeight}}></div>)

    return col
  }
}

export default Column;



// WEBPACK FOOTER //
// ./src/Column/index.js